<template>
  <div class="min-h-screen flex flex-col bg-gray-50">
    <!-- Navigation -->
    <GlobalNavbarNext />
    
    <!-- Main Content -->
    <main class="flex-1">
      <router-view />
    </main>
    
  <!-- Footer -->
    <HomeFooterComponent />
  </div>
</template>

<script setup>
import HomeFooterComponent from '@/components/nav/HomeFooterComponent.vue'
import GlobalNavbarNext from '@/components/nav/GlobalNavbarNext.vue'
</script>